import React from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";

/* BCA Components */
import LoadingContainer from '../LoadingContainer';

/* BCA modules */
import useStyles from '../styles';
import {UserUtils, withEuroOrDash} from "../../../../utils/utils";
import {
  buildCurrentCustomerDashboardPath, buildCurrentCustomerOtherAssetsListPath,
} from "../../../../routes";
import { executeIfPathExist, getInvestmentDynamicPath } from '../../../../containers/InvestmentPlatform/utils'
import {
  ExpandIconButton
} from "../../../../containers/CustomerDashboard/components/Widgets/components/DashboardCard/components/ExpandButton";
import Grid from "@material-ui/core/Grid";
import WarningTooltip from "../../../WarningTooltip";

const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
  investmentPlatform: state.get('investmentPlatform').toJS()
});

const TotalInvestedAmount = (props) => {
  const classes = useStyles();

  const {
    value,
    loading,
    customerId,
    auth,
    otherAssetsLink,
    dashboardLink,
    expandable,
    expanded,
    onExpanded,
    withExpandButton
  } = props;

  const buildAssetLink = () => {
    return buildCurrentCustomerOtherAssetsListPath()
  };

  const buildDashboardLink = () => {
    let path;

    if (UserUtils.isBroker(auth)) {
      executeIfPathExist(props.investmentPlatform.routes, 'DASHBOARD', (dynamicPath) => {
        path = '/' + getInvestmentDynamicPath() + dynamicPath.replace(':customer_id', customerId)
      }, ':customer_id')
    } else {
      path = buildCurrentCustomerDashboardPath()
    }

    return path
  };

  const Header = ({children}) => (
    <div style={{display: 'flex', justifyContent: 'space-between', marginLeft: 'auto', marginRight: 0}}>
      <Grid item>
        <Grid item className={classes.header} style={{
          display: 'flex',
          alignItems: 'center'
        }}>Gesamtvermögen
          <WarningTooltip
            title={`Summe aller vorhandenen Depots${withOtherAssets ? ', Verrechnungskonten und sonstigen Vermögenswerte':' und Verrechnungskonten'} zum gewählten Betrachtungszeitraum.`}
            placement={"top"}
            iconClassName={classes.helpIcon}
          />
        </Grid>
        {children}
      </Grid>
      {!loading && withExpandButton && (
        <Grid item>
          <ExpandIconButton
            expanded={expanded}
            onChanged={() => onExpanded(!expanded)}
          />
        </Grid>
      )}
    </div>
  );

  const withOtherAssets = !!dashboardLink || !!otherAssetsLink;

  return (
    <div className={classes.container}>
      {loading ? (
        <>
          {props.loadingWithTitle && <Header />}
          {props.loadingContent || (<LoadingContainer/>)}
        </>
      ) : (
        <Header>
          <p style={{display: !expandable || expanded ? 'inline' : 'none'}}>
            <p className={classes.subHeader}>
              Bestände inkl. {withOtherAssets ? 'sonstige Vermögenswerte' : 'Verrechnungskonten'}
            </p>
            <p className={classes.value}><span>{withEuroOrDash(value || 0)}</span></p>
            {customerId && otherAssetsLink && (
              <p className={classes.link} >
                <Link to={buildAssetLink()}>Sonstige Vermögenswerte anzeigen</Link>
              </p>
            )}
            {dashboardLink && (
              <p className={classes.link} >
                <Link to={buildDashboardLink()}>Vermögensübersicht anzeigen</Link>
              </p>
            )}
          </p>
        </Header>
      )}

    </div>
  )
};

export default connect(mapStateToProps)(TotalInvestedAmount);
